import { gql } from '@apollo/client';

export const UPDATE_STEALTH_MODE = gql`
  mutation stealth($enabled: Boolean!) {
    updateStealth(enabled: $enabled) {
      success
    }
  }
`;
